import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Model } from '../../models/model.model';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';

@Injectable({
  providedIn: 'root'
})
export class ModelsService {
  
  gnBaseURL: any;
  constructor(private http: HttpClient,private appURL: AppConfigService) {
    this.gnBaseURL=this.appURL.getServerUrl(); 
  }

  getAllModel(): Observable<Model[]> {
    return this.http.get<Model[]>(this.gnBaseURL + 'Model/GetModelList');
  }
  getAllModelForNonAdminUser(): Observable<Model[]> {
    return this.http.get<Model[]>(this.gnBaseURL + 'Model/GetModelListForNonAdminUser');
  }
  addModel(
    addModelRequest: Model
  ): Observable<Model> {
   
    return this.http.post<Model>(
      this.gnBaseURL + 'Model/AddModel',
      addModelRequest
    );
  }

  getModel(id: string): Observable<Model> {
    return this.http.get<Model>(this.gnBaseURL + 'Model/GetModelById/' + id);
  }

  updateModel(
    id: number,
    updateModelRequest: Model
  ): Observable<Model> {
    return this.http.post<Model>(
      this.gnBaseURL + 'Model/EditModel/' + id,
      updateModelRequest
    );
  }

  deleteModel(id: number): Observable<Model> {
    return this.http.delete<Model>(this.gnBaseURL + 'Model/' + id);
  }
}


